module.exports = __webpack_public_path__ + "static/img/img-cp5-1.d537388.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp5-1.png
// module id = XRJ1
// module chunks = 0